
export const extractCommunityInfo = (emailAction) => {
  if (emailAction?.action === "InviteFriend") {
    const invitedCommunityName = emailAction.tenantName?.trim() || null;
    const invitedCommunityId = emailAction.tenantId
      ? Number(String(emailAction.tenantId).replace(/,/g, ""))
      : null;
    const invitedEmailId = emailAction.emailId || null;
    const invitationToken = emailAction.invitationToken || emailAction.token || null;
    const inviterInfo = emailAction.inviterInfo || null;
    const tenantId = emailAction.tenantId || null;

    return {
      invitedCommunityName,
      invitedCommunityId,
      invitedEmailId,
      invitationToken,
      inviterInfo,
      tenantId,
    };
  }

  // Default: if no InviteFriend action
  return {
    invitedCommunityName: null,
    invitedCommunityId: null,
    invitedEmailId: null,
    invitationToken: null,
    inviterInfo: null,
    tenantId: null,
  };
};
